<script lang="ts">
      import { page } from '$app/state'
      import { getBodyContext } from '$lib/components/context/ts/BodyContext.svelte'
      import { getDebugContext } from '$lib/components/context/ts/Debug.svelte'
      import Close from '$lib/components/ui/Close.svelte'
      import { getScrollBlockContext } from '$lib/ui/menu/index.svelte'
      import Icon from '../Icon.svelte'
      import type { MenuItem } from '../Menu'
      import MenuButtonItem from './MenuButtonItem.svelte'
      import MenuButtonSubmenu from './MenuButtonSubmenu.svelte'

      import { onMount, tick } from 'svelte'


      async function toggleMenu() {
            body.toggle()
            //if (visible == false) sb.releaseBodyScrollBlock(menu)
            //else sb.requestBodyScrollBlock(menu)
      }

      async function closeMenu() {

      }

      $effect( () => {
        //if( visible ) body.open()
        //else body.close()
      })


      onMount( () => {
        window._page = page
      })
      
      let menu: HTMLDivElement
      
      const sb = getScrollBlockContext()
      
      const body = getBodyContext()
      
      let visible = $derived( body.opened )
      
      let { class: className = '' }: {  class: string } = $props()
</script>

<div bind:this={menu} class="{className} absolute top-0 right-0 h-full aspect-square bg-transparent z-50 mr-2 md:mr-6">
      <button class="h-full w-full text-right text-2xl transition-all ease-in-out duration-700 hover:opacity-100 relative {visible ? '' : ''}" onclick={toggleMenu}>
            <div class="h-[60%]">
                  <Icon open={body.opened}></Icon>
            </div>
      </button>


</div>

<style lang=postcss>
      .menu {
            /*scrollbar-gutter: stable;*/
            width: 0px;
            height: 0px;
      }

      .menu:global(.open) {
            width: 100%;
            height: 100%;
      }

      .menu:global(.open) .menu-icon {
        @apply mix-blend-difference;
      }
</style>
